import { PetOwnerFormValues } from '@app/shared/components/pet-owner-form/pet-owner-form';
import { createAction, props } from '@ngrx/store';

/**
 * Actions to set forms
 */
export const setNewPetOwnerValues = createAction('[New Pet] Set Owner Values', props<{ value: PetOwnerFormValues }>());
/**
 * Action to create pet
 */
export const createNewPet = createAction('[New Pet] Create New Pet');
